import React, { useState } from "react";
import "./Products.css";

import Img1 from "./Assets/Group 1171275319.png";
import Img2 from "./Assets/Group 1171275326.png";
import Img3 from "./Assets/Group 1171275321.png";
import StarIcon from "./Assets/Text Ellipse.png";

function Products() {
  const [active, setActive] = useState(1);

  const items = {
    1: {
      num: "01",
      title: "Decision making, redefined with Meta stockpicker",
      desc:
        "Meta stockpicker lets you skip endless tables and spot stock patterns instantly. It delivers real-time, visual insights for smarter, faster, data-backed decisions with ease.",
      img: Img1,
      url: "https://metastockpicker.com/",
    },
    2: {
      num: "02",
      title: "Daily Astrology Reimagined with Myluckydays",
      desc:
        "My Lucky Days (MLD) uses AR to bring the stars alive, combining ancient Vedic wisdom with real-time forecasts, emotional tracking, and helping you flow with the universe.",
      img: Img2,
      url: "https://play.google.com/store/apps/details?id=tech.kushmanda.luckydays&hl=en_IN",
    },
    3: {
      num: "03",
      title: "Wiki Bedtime stories – where stories meet serenity.",
      desc:
        "Wiki Bedtime Stories blends timeless wisdom with modern wellbeing — offering calming, culturally rich stories that support restful sleep for kids of all ages.",
      img: Img3,
      url: "https://wikibedtimestories.com",
    },
  };

  return (
    <div className="section-container">
      <h1 className="section-title">Explore our products</h1>

      <div className="content-wrapper">
        <div className="left-column">
          <div className="full-vertical-line"></div>

          <div
            className="active-highlight"
            style={{ top: `${(active - 1) * 210}px` }}
          ></div>

          <div className="items-list">
            {Object.keys(items).map((key) => {
              const item = items[key];
              const isActive = Number(key) === active;

              return (
                <div
                  key={key}
                  className="item-block"
                  onClick={() => setActive(Number(key))}
                >
                  <span className={`item-number ${isActive ? "num-active" : ""}`}>
                    {item.num}
                  </span>

                  <div className="text-side">
                    <h2
                      className={`item-title ${isActive ? "gradient-text" : ""}`}
                      onClick={(e) => {
                        if (!isActive) return; // ❌ inactive = no redirect
                        e.stopPropagation();
                        window.open(item.url, "_blank"); // ✅ only active opens
                      }}
                      style={{ cursor: isActive ? "pointer" : "default" }}
                    >
                      {item.title}

                      {isActive && (
                        <img src={StarIcon} alt="star" className="star-icon" />
                      )}
                    </h2>

                    <p className="item-desc">{item.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="right-column">
          <img src={items[active].img} className="right-img" />
        </div>
      </div>
    </div>
  );
}

export default Products;
